import React, {useState} from "react";
import DeleteIcon from "@material-ui/icons/Delete";
import clsx from "clsx";
import {Box, IconButton, useTheme} from "@material-ui/core";
import {MessageFile} from "ts/api/chat";
import File from "../Files/File";
import {useStyles} from "./style";

type LoadedFileProps = {
  file: MessageFile;
  messageId: string;
  onDelete: (
    messageId: string,
    deleteType: string,
    fileId?: string,
    fileName?: string
  ) => void;
  isSender?: boolean;
};

const LoadedFile = ({file, onDelete, messageId, isSender}: LoadedFileProps) => {
  const classes = useStyles();
  const theme = useTheme();
  const [isHovered, setIsHovered] = useState(false);
  return (
    <Box
      className={clsx(classes.fileContainer, {
        [classes.fileLeft]: !isSender,
        [classes.fileRight]: isSender,
      })}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {isSender && isHovered && (
        <Box className={classes.actionButtons}>
          <IconButton
            size="small"
            onClick={() => onDelete(messageId, "file", file.id, file.name)}
          >
            <DeleteIcon htmlColor={theme.palette.contrastIcon.main} />
          </IconButton>
        </Box>
      )}
      <Box
        maxWidth="600px"
        className={isSender ? classes.fileRight : classes.fileLeft}
      >
        <File file={file} isSender={isSender} />
      </Box>
    </Box>
  );
};

export default LoadedFile;
